import React from "react";
import { connect } from "react-redux";

// Components
import { createTheme } from "theme";
import { ThemeProvider } from "@material-ui/core";
import Routes from "./Routes";

type Props = {
  authenticated: boolean
}

const App : React.FC<Props> = ({ authenticated }) => {

  const theme = createTheme()

  return (
    <ThemeProvider theme={theme}>
       <Routes authenticated={authenticated} />
    </ThemeProvider>
  )

};

export default App;
